ci_states.state('roles', {
    url: '/roles',
    templateUrl: 'partials/role/role_list.html',
    controller: 'RoleListController',
    ncyBreadcrumb: {
        label: 'Roles'
    }
}).state('roles_view', {
    url: '/roles/:id',
    templateUrl: 'partials/role/role_view.html',
    controller: 'RoleViewController',
    abstract: true,
    ncyBreadcrumb: {
        parent: 'roles',
        label: '{{ role.name }}'
    }
}).state('roles_view.users', {
    url: '/users',
    templateUrl: 'partials/role/role_view_users.html',
    ncyBreadcrumb: {
        label: 'Users'
    }
}).state('roles_view.permissions', {
    url: '/permissions',
    templateUrl: 'partials/role/role_view_permissions.html',
    ncyBreadcrumb: {
        label: 'Permissions'
    }
});